export default __webpack_public_path__ + "static/media/(1).6bb68b47.png";